export const se = {
    // Login screen
    modal_login_capital: 'LOGGA IN',
    placeholder_email_address: 'etikett e-post',
    placeholder_password: 'etikett lösenord',
    tooltip_forgot_password: 'Glömt lösenord?',
    log_in: 'Logga in',

    // Register screen
    modal_signup_capital: 'BLI MEDLEM',
    placeholder_repeat_password: 'upprepa lösenordet',
    agree: 'Jag godkänner ',
    terms: 'Villkor',
    modal_register_capital: 'REGISTRERA',
    full_name: 'Fullständigt namn',

    // Price options
    choose_price: 'VÄLJ DITT PRIS',
    subscription_price: 'Prenumeration',
    asset_price: 'Tillgång',
    paywall_subscription_text:
        'Du kan när som helst avbryta din prenumeration.',
    modal_back: 'TILBAKA',
    next_button: 'NÄSTA',

    // Payments screen
    pay: 'BETALA',
    pay_with: 'BETALA MED PAYPAL',
    credit_card: 'kreditkort',
    payment_pay: 'Betala',
    payment_price: 'Pris',
    placeholder_voucher_code: 'rabattkod',
    placeholder_voucher: 'lägg till kupong',
    card_number: 'kortnummer',
    cardholder_name: 'kortinnehavarens namn',

    // Forgot password
    forgot_pass_text:
        'Vi skickar en länk till din e-post för att återställa ditt lösenord.',
    remember_pass: ' Kommer du ihåg lösenordet?',
    reset: 'ÅTERSTÄLL',

    // Set new password
    modal_enter_your_new_password: 'Ange ditt nya lösenord.',
    modal_please_check_your_email:
        'Vänligen kontrollera din e-post och kopiera tecknet för att fullfölja.',
    placeholder_token: 'tecken',
    new_password: 'nytt lösenord',
    repeat_new_password: 'upprepa nytt lösenord',
    cancel: 'avbryt',
    set: 'KLAR',

    // Change password
    update: 'uppdatering',
    change_pass: 'Change password',

    // Account
    user_menu_my_account: 'Mitt kont',
    member_since: 'Medlem sedan',
    purchases: 'Mina inköp',
    subscriptions: 'Mina prenumerationer',
    account_details: 'Kontouppgifter',
    export_data: 'Exportera min information',
    delete_account: 'Radera konto',

    // Purchases/Subscriptions
    purchases_link: 'Inköp',
    subscriptions_link: 'Prenumerationer',
    subscriptions_text:
        'These are all the assets you have purchased and how long you have access to it.',
    purchase_history: 'Köphistorik',
    purchased: 'Köpt',
    name: 'namn',
    active: 'aktiv',
    inactive: 'inactive',
    canceled: 'avbrutet',
    type: 'Typ',
    next_transaction: 'nästa transaktion',
    cancel_subscription: 'Avbryt prenumeration >',
    subscriptions_active: 'Aktiva prenumerationer',
    expires_at: 'Upphör vid',
    no_more_subscriptions: 'Det finns inga fler prenumerationer.',
    no_available_subscriptions: 'Det finns inga tillgängliga prenumerationer.',
    no_more_active_accesses: 'Det finns inga fler aktiva åtkomster.',
    no_more_inactive_accesses: 'Det finns inga fler inaktiva åtkomster.',
    no_available_active_accesses:
        'Det finns inga tillgängliga aktiva åtkomster.',
    no_available_inactive_accesses:
        'Det finns inga tillgängliga inaktiva åtkomster.',
    subscription: 'Subscription',
    free_trial: 'Free Trial',
    cancel_subscription_header:
        'Are you sure you want to cancel your subscription?',
    cancel_subscription_paragraph_first:
        'This will end your subscription for the',
    cancel_subscription_paragraph_second:
        'You will still have access to everything until the active period ends on the',
    cancel_subscription_confirm: 'Yes, cancel',
    will_end: 'Subscription will end',

    // Export data screen
    export_question:
        'Är du säker på att du vill exportera din kontoinformation?',
    export: 'exportera',
    first_export:
        'Kontoinformations export-åtgärd exporterar alla dina personuppgifter för ditt konto. Det inkluderar följande:',
    second_export: 'Din personliga information',
    third_export: 'Lista av dina inloggnings uppgifter',
    fourth_export: 'Lista av dina prenumerationer',
    fifth_export: 'Lista av dina betalningar',
    sixth_export: 'Lista av dina åtkomster till premium innehåll',
    last_export: 'Exporten skickas till din e-postadress som bifogad fil.',

    // Delete account screen
    delete_question: 'Är du säker på att du vill radera ditt konto?',
    delete: 'radera',
    confirm: '‘BEKRÄFTA',
    first_delete:
        'Radera kontoåtgärd kommer radera alla dina personuppgifter från systemet. Det inkluderar följande:',
    second_delete: 'Personuppgifter som du lämnat under registreringsprocessen',
    third_delete:
        'Plats- och enhetsinformation som vi samlar under bekräftelse processen',
    fourth_delete:
        'All annan personlig information lagrad i andra delar av vår databas',
    fifth_delete:
        'De enda personuppgifter vi kommer att behålla i systemet är en som ingår i transaktionerna och prenumerationerna på grund av annan lagstiftning som vi måste följa.',
    sixth_delete:
        'Förutom att datasökningen avaktiveras från ditt konto, vilket innebär att alla dina aktiva prenumerationer avbryts. Alla dina aktiva åtkomster till tillgångar kommer att återkallas och alla dina aktiva inloggnings sessioner inklusive den här kommer att avslutas. Du kommer inte längre att kunna verifiera och köpa tillgångar på den här webbplatsen. Din kontoinformation kommer inte längre att vara tillgänglig i någon lista till våra medarbetare.',
    seventh_delete:
        'Den här åtgärden kan ta 1-2 dagar att slutföra, varefter ett bekräftelse-post meddelande skickas till din e-postadress. E-postmeddelandet raderas från vårt system efter lyckad leverans.',

    // Inputs validation
    required_field: 'Obligatoriskt fält',
    email_field: 'vänligen ange en korrekt e-postadress',
    number_field: 'Värdet måste vara ett tal',
    matchPass: 'lösenordet matchar inte',
    minpass_field: 'måste vara minst 8 tecken långt',
    minname_field: 'måste vara minst 2 tecken långt',

    // Footer
    modal_terms: 'Villkor',
    modal_privacy: 'Privacy',
    modal_more: 'MER',
    modal_faq: 'FAQ',
    modal_protected: 'Vad är detta?',
    logout: 'Logga ut',
    details: 'Mina detaljer',
    preview_protected_by_inplayer: 'Skyddad av',
    modal_support: 'Support',

    dlc_download: 'ladda ner',
};



// WEBPACK FOOTER //
// ./src/i18n/swedish.js